export default __webpack_public_path__ + "static/media/empty_theme.91167ab3.svg";